<script lang="ts" setup>
import { useDateStore } from './stores/dateStore'

const dateStore = useDateStore()
dateStore.init()
</script>

<template>
  <v-app>
    <RouterView />
    <IdleSessionTimeoutModal />
  </v-app>
</template>
